import { render, staticRenderFns } from "./kayip_raporu.vue?vue&type=template&id=63595030&scoped=true&"
import script from "./kayip_raporu.vue?vue&type=script&lang=js&"
export * from "./kayip_raporu.vue?vue&type=script&lang=js&"
import style0 from "./kayip_raporu.vue?vue&type=style&index=0&id=63595030&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63595030",
  null
  
)

export default component.exports